import { render, staticRenderFns } from "./newsAndInformationModal.vue?vue&type=template&id=f50ae2c6"
import script from "./newsAndInformationModal.vue?vue&type=script&lang=js"
export * from "./newsAndInformationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports